import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PictureViewerComponent } from './picture-viewer.component';
import { PictureViewerService } from './picture-viewer.service';
import { SharedModule } from 'app/components/shared.module';



@NgModule({
  declarations: [PictureViewerComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [PictureViewerComponent],
//  entryComponents: [PictureViewerComponent],
  providers: [PictureViewerService]
})
export class PictureViewerModule { }
